module.exports = __webpack_public_path__ + "img/img12.dde5c80a.svg";